import React from "react";
import { Col, Row } from "react-bootstrap";
import SkirtsAdmin from "../../../components/skirts-admin/SkirtsAdmin";

const MenuSkirts = () => {
  return (
    <Row>
      <Col col={12} className="col-12 mb-3">
        <SkirtsAdmin />
      </Col>
    </Row>
  );
};

export default MenuSkirts;
